import {observer} from "mobx-react";
import React from "react";
import {H2hWidgetTabs} from "./h2h-widget.tabs";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {H2hWidgetController} from "../h2h-widget.controller";
import styles from '../styles/h2h-widget.module.scss';
import classnames from "classnames";

export class H2hWidgetHeaderProps extends BaseProps {
  controller: H2hWidgetController;
}

export const H2hWidgetHeader = observer(({controller}: H2hWidgetHeaderProps) => {
  const {state: {shouldRenderTabs}} = controller;

  const placeholderProps = {
    className: classnames(styles.tabs_space)
  }

  return shouldRenderTabs ? <H2hWidgetTabs controller={controller}/> : <div {...placeholderProps}/>;
});
